<template>
    <b-container fluid>
        <b-row>
            <b-col>
                <div class="my-3 p-3 bg-white rounded shadow-sm"> 
                    <h4 class="border-bottom border-gray pb-2 mb-0">Ordenes</h4>
                    <div class="media text-muted pt-3"> 
                        <b-table :items="orders" :fields="fields"  :current-page="packagesTable.currentPage"
                    :per-page="packagesTable.perPage"
                    :filter="packagesTable.filter"
                    :filterIncludedFields="packagesTable.filterOn">
                    

                         <template v-slot:cell(packPrice)="row">
                            {{Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(row.item.packPrice)}}
                        </template>
                        <template v-slot:cell(date)="row">
                            {{ row.item.date | formatDate }} 
                        </template>
                        <template v-slot:cell(actions)="row">
                     
                            <b-button
                                size="sm"
                                @click="modalDelete(row.item)"
                                class="mr-1"
                                variant="danger"
                            >
                                <i class="far fa-trash-alt"></i>
                            </b-button>
                            <b-button 
                                v-if="row.item.status == false"
                                size="sm"
                                @click="checker(row.item)"
                                class="mr-1 btn_editar"
                                >
                                <i class="fas fa-check"></i>
                            </b-button>
                        </template>
                    </b-table> 
                    </div>
                    <div style="width: 500px;">
                        <b-pagination
                            v-model="packagesTable.currentPage"
                            :total-rows="packagesTable.totalRows"
                            :per-page="packagesTable.perPage"
                            align="fill"
                            size="sm"
                            class="my-0"
                        ></b-pagination>
                    </div>
                </div> 
            </b-col>
        </b-row>
        
    </b-container>
</template>

<script>
import axios from "axios";
export default {
    data() {
        return {
            orders: [],
            items: [
                { age: 40, first_name: 'Dickerson', last_name: 'Macdonald' },
                { age: 21, first_name: 'Larsen', last_name: 'Shaw' },
                { age: 89, first_name: 'Geneva', last_name: 'Wilson' },
                { age: 38, first_name: 'Jami', last_name: 'Carney' }
            ],
            fields: [ 
                { key: 'date', label: 'Fecha' },  
                { key: 'firstname', label: 'Nombre' },
                { key: 'lastname', label: 'Apellido' },
                { key: 'email', label: 'Email' },
                { key: 'phoneNumber', label: 'Telefono' },
                { key: 'direction', label: 'Dirección' },
                { key: 'city', label: 'Ciudad' },
                { key: 'pack', label: 'Paquete' }, 
                { key: 'packPrice', label: 'Precio paquete'},
                { key: 'actions', label: '' }
            ],
            packagesTable: { 
                totalRows: 1,
                currentPage: 1,
                perPage: 5,
                pageOptions: [5, 10, 15],
                filter: null,
                filtpackagesTableerOn: []
            },
            deleteModal: {
                id: "info-modal",
                title: "",
                eliminar: null
            }
        }
    },
     
    created() {
        this.gets();
    },
    methods: {
        gets() { 
            axios
            .get("orders")
            .then(res => { 
                if (res.data) {  
                    this.orders = res.data;
                    this.packagesTable.totalRows = res.data.length;
                } 
            })
            .catch(error => {
                this.isLoading = false; 
            });
        },
        modalDelete(item) { 
            axios
            .delete("order/"+item._id)
            .then(res => { 
               this.gets();
            })
            .catch(error => {
                this.isLoading = false; 
            });
        },
        checker(item) {   
            axios
            .put("order/"+item._id)
            .then(res => { 
               this.gets();
               this.$emit('update-orders');
            })
            .catch(error => {
                this.isLoading = false; 
            });
        },
    }
}
</script>